// extracted by mini-css-extract-plugin
export default {"Rating":"styles_Rating__nbeVz","Review":"styles_Review__DNjqe","Quotes":"styles_Quotes__c5pDU","Person":"styles_Person__Ty6y6","Footer":"styles_Footer__42sC-"};